import { useState, useCallback } from "react";
import { AxiosError, AxiosRequestConfig } from "axios";
import { axiosInstance } from "../utils/requests";

export function useHttp<T>(url: string, defaultOptions?: AxiosRequestConfig, return_response: boolean = false) {
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<AxiosError | null>(null);

  const fetchData = useCallback(
    async (urlOrOptions?: string | AxiosRequestConfig, maybeOptions?: AxiosRequestConfig) => {
      setLoading(true);
      setError(null);

      const isString = typeof urlOrOptions === "string";
      const fetchUrl = isString ? urlOrOptions! : url;
      const opts = isString ? maybeOptions : urlOrOptions;

      try {
        const response = await axiosInstance(url, {
          ...defaultOptions,
          ...opts,
          withCredentials: true,
        });
        setData(response.data);
        if (return_response) return response;
        else return response.data;
      } catch (err: any) {
        setError(err);
        if (return_response) throw err;
      } finally {
        setLoading(false);
      }
    },
    [url, defaultOptions, return_response],
  );

  return { data, loading, error, trigger: fetchData };
}
